import {OpenHoursSchema, type OpenHoursType} from "../types";
import {z} from "zod";

export class OpenHours {

    // public static getOpenHours() {
    //     return {
    //         "friday": {"open": "08:00", "close": "18:00"},
    //         "monday": {"open": "08:00", "close": "18:00"},
    //         "sunday": {"open": "08:00", "close": "18:00"},
    //         "tuesday": {"open": "08:00", "close": "18:00"},
    //         "saturday": {"open": "08:00", "close": "18:00"},
    //         "thursday": {"open": "08:00", "close": "18:00"},
    //         "wednesday": {"open": "08:00", "close": "18:00"}
    //     }
    // }

    public static getWeekDayForGivenDateYYYYMMDD(date: string) {
        let weekDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        let d = (new Date(date));
        return weekDays[d.getDay()];
    }

    public static isOpenThisDay(openHours: OpenHoursType, date: string) {
        try {
            return this.getWorkTimeDurationSeconds(openHours, date) > 0;
            // OpenHoursSchema.parse(openHours);
            // let weekDay = OpenHours.getWeekDayForGivenDateYYYYMMDD(date);
            // if (openHours[weekDay] === undefined) return false;
            // if (
            //     z.string().regex(/^(\d{1,2}:\d{2})$/).safeParse(openHours[weekDay].open).success
            //     &&
            //     z.string().regex(/^(\d{1,2}:\d{2})$/).safeParse(openHours[weekDay].close).success
            // ) return true;
        } catch (e) {
            console.warn('OpenHours.isOpenThisDay', e);
        }
        return false;
    }
    
    public static getWorkTimeDurationSeconds(openHours: OpenHoursType, date: string): number {
        try {
            OpenHoursSchema.parse(openHours);
            let weekDay = OpenHours.getWeekDayForGivenDateYYYYMMDD(date);
            if (openHours[weekDay] === undefined) return 0;
            let open = z.string().regex(/^(\d{1,2}:\d{2})$/).safeParse(openHours[weekDay].open);
            let close = z.string().regex(/^(\d{1,2}:\d{2})$/).safeParse(openHours[weekDay].close);
            if (open.success && close.success) {
                let openTime = open.data.split(':');
                let closeTime = close.data.split(':');
                let openDate = new Date(date);
                openDate.setHours(parseInt(openTime[0]), parseInt(openTime[1]), 0, 0);
                let closeDate = new Date(date);
                closeDate.setHours(parseInt(closeTime[0]), parseInt(closeTime[1]), 0, 0);
                return Math.max(0, (closeDate.getTime() - openDate.getTime()) / 1000);
            }
        } catch (e) {
            console.warn('OpenHours.getWorkTimeDuration', e);
        }
        return 0;
    }
    
    public static getWorkTimeStartSeconds(openHours: OpenHoursType, date: string): number | null {
        try {
            OpenHoursSchema.parse(openHours);
            let weekDay = OpenHours.getWeekDayForGivenDateYYYYMMDD(date);
            if (openHours[weekDay] === undefined) return null;
            let open = z.string().regex(/^(\d{1,2}:\d{2})$/).safeParse(openHours[weekDay].open);
            if (open.success) {
                return parseInt(open.data.split(':')[0]) * 3600 + parseInt(open.data.split(':')[1]) * 60;
            }
        } catch (e) {
            console.warn('OpenHours.getWorkTimeStart', e);
        }
        return null;
    }
    
    public static getWorkTimeEndSeconds(openHours: OpenHoursType, date: string): number | null {
        try {
            OpenHoursSchema.parse(openHours);
            let weekDay = OpenHours.getWeekDayForGivenDateYYYYMMDD(date);
            if (openHours[weekDay] === undefined) return null;
            let close = z.string().regex(/^(\d{1,2}:\d{2})$/).safeParse(openHours[weekDay].close);
            if (close.success) {
                return parseInt(close.data.split(':')[0]) * 3600 + parseInt(close.data.split(':')[1]) * 60;
            }
        } catch (e) {
            console.warn('OpenHours.getWorkTimeEnd', e);
        }
        return null;
    }

}